import { createTheme } from '@mui/material/styles';

// Create a CSS string to inject into the theme
const globalStyles = `
  .MuiTableContainer-root { overflow-x: hidden !important; width: 100% !important; max-width: 100% !important; }
  .MuiTable-root { width: 100% !important; table-layout: fixed !important; }
  .MuiTableCell-root { white-space: normal !important; word-break: break-word !important; overflow: hidden !important; max-width: 1px !important; }
  .MuiPaper-root { overflow-x: hidden !important; max-width: 100% !important; }
  .MuiContainer-root { overflow-x: hidden !important; max-width: 100% !important; }
  .MuiBox-root { overflow-x: hidden !important; max-width: 100% !important; }
  body { overflow-x: hidden !important; }
`;

// Create light theme with custom primary color
export const customLightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#2D4D6E',
      contrastText: '#fff',
    },
    background: {
      default: '#f5f5f5',
      paper: '#fff',
    },
  },
  components: {
    // Control drawer behavior
    MuiDrawer: {
      defaultProps: {
        variant: 'persistent',
        ModalProps: { keepMounted: true },
      },
    },
    // Add global styles via MuiCssBaseline
    MuiCssBaseline: {
      styleOverrides: globalStyles,
    },
  },
});

// Create dark theme with custom primary color
export const customDarkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#2D4D6E',
      contrastText: '#fff',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
  },
  components: {
    // Control drawer behavior
    MuiDrawer: {
      defaultProps: {
        variant: 'persistent',
        ModalProps: { keepMounted: true },
      },
    },
    // Add global styles via MuiCssBaseline
    MuiCssBaseline: {
      styleOverrides: globalStyles,
    },
  },
});

export { ColorModeContext } from './ColorModeContext';
export { ColorModeContextProvider } from './ColorMode';
